import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'
import { permissionDirective } from './directives/permission'
import { setupMock } from './mock'
import 'element-plus/dist/index.css'
import './assets/styles/global.css'
import './assets/styles/h5.css'

// Initialize mock server before anything that might trigger API calls
setupMock()

const app = createApp(App)

// Register Element Plus icons — skip 'default' key from Vite pre-bundle
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  if (key !== 'default' && typeof component === 'object') {
    app.component(key, component as any)
  }
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus, { size: 'default' })
app.directive('permission', permissionDirective)

app.mount('#app')
